import React, { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { profileService } from '../../services/profileService';

interface ProtectedRouteProps {
  children: ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const [profileChecked, setProfileChecked] = React.useState(false);
  const [hasProfile, setHasProfile] = React.useState(false);
  const location = useLocation();

  React.useEffect(() => {
    if (isAuthenticated) {
      profileService.getProfile().then(prof => {
        setHasProfile(!!(prof && prof.dob));
        setProfileChecked(true);
      }).catch(() => {
        setProfileChecked(true);
      });
    }
  }, [isAuthenticated]);

  if (loading || (isAuthenticated && !profileChecked)) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Enforce profile completion for protected routes (except the profile page itself)
  if (!hasProfile && location.pathname !== '/profile') {
    return <Navigate to="/profile?onboarding=true" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
